/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { Input } from 'reactstrap';
import { ColumnInputProps } from '../InputInterface';

export default function TextInput(props: ColumnInputProps) {
  const {
    isDisabled,
    column,
    inputColumn,
    handleFocus,
    updateColumn,
    placeholder,
    label,
  } = props;

  const currentValue = inputColumn.value || '';

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    e.preventDefault();
    const { name, value } = e.target;
    return updateColumn({
      code: name,
      value: value === '' ? undefined : value
    });
  };

  const disabled = isDisabled?.(props);
  const maxLength = Number(column.validation?.max);

  if (maxLength > 1 && maxLength < 100) {
    return <div className='mb-3'>
      {label}
      <Input
        className='styled-input'
        autoComplete='off'
        type='text'
        id={column.code}
        name={column.code}
        value={currentValue}
        placeholder={placeholder}
        disabled={!!disabled}
        required={true}
        onFocus={handleFocus}
        onClick={handleFocus}
        onChange={onChange} />
    </div>
  } else {
    return <div className='mb-3'>
      {label}
      <Input
        type='textarea'
        className='styled-input'
        rows={5}
        id={column.code}
        name={column.code}
        value={currentValue}
        placeholder={placeholder}
        disabled={!!disabled}
        required={true}
        onFocus={handleFocus}
        onClick={handleFocus}
        onChange={onChange} />
    </div>
  }
}
